import React from 'react'
import { Link } from 'react-router-dom'
import { formatValueV2 } from '../helpers/funcs'

const CountryTable = props => {
    const { cols, countries, sortBy } = props
    return (
        <table className="table countryList table-hover table-striped bg-light">
            <thead style={{ backgroundColor: '#1c364e', color: '#FFF' }}>
                <tr className="th-sorting">
                    {cols && cols.map((col, idx) => (
                        <th key={idx} onClick={e => props.handleSorting(e, col.id || col.label)} colSpan={col.colSpan || 1} className={col.className || ''}>
                            <span>{col.label}</span>
                            {' '}
                            {sortBy.key === (col.id || col.label) && (
                                <i className={`fas fa-${sortBy.type === 'asc' ? 'caret-up' : 'caret-down'}`} />
                            )}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {countries && countries.length ? countries.filter(c => !c.hidden).map((c, idx) => (
                    <tr key={idx} className={c.hidden ? 'd-none' : ''}>
                        <td style={{ width: '40px' }} className="text-center vertical-align-middle">
                            {c.ContributorType === 'Country' ? (
                                <Link to={`/contributor/${c.ContributorID}`}>
                                    <img alt={c.ISO3} src={`https://ipmsapplication.blob.core.windows.net/public/images/flags/24/${c.ISO2.toLowerCase()}.png`} width="24" height="24" />
                                </Link>
                            ) : (
                                    <i className="fa fa-building text-secondary" />
                                )}
                        </td>
                        <td><Link to={`/contributor/${c.ContributorID}`}><strong>{c.CountryName || c.Name}</strong></Link></td>
                        <td style={{ width: '200px' }} className="text-right"><Link to={`/contributor/${c.ContributorID}`}>{(c.AnnouncedUSD && formatValueV2(c.AnnouncedUSD)) || '-'}</Link></td>
                        <td style={{ width: '200px' }} className="text-right"><Link to={`/contributor/${c.ContributorID}`}>{(c.SignedUSD && formatValueV2(c.SignedUSD)) || '-'}</Link></td>
                        <td style={{ width: '200px' }} className="text-right"><Link to={`/contributor/${c.ContributorID}`}>{(c.SignedPC && c.SignedPC > 0 && formatValueV2(c.SignedPC, '$0,0.00')) || '-'}</Link></td>
                        <td style={{ width: '200px' }} className="text-right"><Link to={`/contributor/${c.ContributorID}`}>{(c.GDPPC && formatValueV2(c.GDPPC)) || '-'}</Link></td>
                        <td style={{ width: '200px' }} className="text-center"><Link to={`/contributor/${c.ContributorID}`}>{c.EmissionsPC && c.EmissionsPC > 0 ? c.EmissionsPC.toFixed(2) : '-'}</Link></td>
                    </tr>
                )) : null}
            </tbody>
        </table>
    )
}

export default CountryTable